import { Grid } from '@mui/material'
import { FormField, FormFieldAutoCompleteMap } from 'global/components/Form'
import { IMapHandlerProps, MapComponent } from 'global/components/Map'
import { useRef } from 'react'
import { useFormContext } from 'react-hook-form'
import { getGeocode } from 'use-places-autocomplete'

type Position = google.maps.LatLngLiteral

type FormProps = {
    latitude: number
    longitude: number
    cercaEletronica: number
    endereco: string
}

export const LocalForm = () => {
    const mapRef = useRef<IMapHandlerProps>(null)
    const { setValue, watch } = useFormContext<FormProps>()

    const { cercaEletronica, latitude, longitude } = watch()

    const handleSetCircleMarker = (ev: any) => {
        const { value } = ev.target
        mapRef.current?.setMarkerCircle(+value)
    }

    const handleGetMapPosition = async ({ lat, lng }: Position) => {
        setValue('latitude', lat)
        setValue('longitude', lng)

        const address = await getGeocode({ location: { lat, lng } })
        const first = address.at(0)

        if (first) {
            setValue('endereco', first.formatted_address, {
                shouldDirty: true,
                shouldTouch: true,
            })
        }
    }

    const handleSetOffice = ({ lat, lng }: Position) => {
        mapRef.current?.setMapPosition({ lat, lng })
        mapRef.current?.setMapZoom(16)

        setValue('latitude', lat)
        setValue('longitude', lng)
    }

    return (
        <Grid container spacing={1} columnSpacing={2}>
            <Grid item xs={8.5}>
                <FormFieldAutoCompleteMap
                    name="endereco"
                    label="Endereço"
                    setOffice={handleSetOffice}
                    required
                />
            </Grid>
            <Grid item xs={3.5}>
                <FormField
                    name="cercaEletronica"
                    label="Cerca Eletrônica (m)"
                    onChange={handleSetCircleMarker}
                    required
                />
            </Grid>
            <Grid item xs={12}>
                <MapComponent
                    height="20rem"
                    getMapPosition={handleGetMapPosition}
                    ref={mapRef}
                    lat={+latitude}
                    lng={+longitude}
                    radius={+cercaEletronica}
                />
            </Grid>
        </Grid>
    )
}
